module.exports = __webpack_public_path__ + "static/media/10.4802d311.jpg";